import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  openCart: null,
  closeCart: ['payload'],
  checkoutRequest: null,
}, { prefix: '[CART] ' });
